import { useEffect, useState, React } from "react";
import { useNavigate } from "react-router-dom"
import Form from "react-bootstrap/Form";
import axios from "axios";
//Hooks
import { useAuthContext } from "../Hooks/useAuthContext";
// Images


export default function RequestResetPassword() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [loginErr, setLoginErr] = useState("");
    const [form, setForm] = useState({});
    const [formErrors, setFormErrors] = useState();
    const { dispatch } = useAuthContext();
    const [resetSent, setResetSent] = useState(false);

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    useEffect(() => {


    }, [form]);


    const handleSubmit = (event) => {
        event.preventDefault();

        setFormErrors({
            email: form.email == undefined || form.email == "",
        });


        if (event.currentTarget.checkValidity()) {
            axios
                .put(`https://${process.env.REACT_APP_IP}/api/users/${form.email}/requestresetpassword/`)
                .then((res) => {
                    setResetSent(true)
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.status === 400) {
                        setLoginErr(err.response.data[0]);
                    }
                });
        }
    }




    
    
    return (
        <main className="justify-content-center row align-content-center px-2 px-md-0" style={{ height: "90vh" }}>
            <div className="loginForm shadow p-3 col-md-5">
                <h1 className="text-center mb-3">Reset Password</h1>

                {resetSent && (<p>A link to reset your password has now been sent to {form.email}. Please click the link to reset your password</p>)}
                {!resetSent && (
                    <Form onSubmit={handleSubmit} noValidate >
                        <p>To reset your password, please enter your email address below. A reset link will be sent to this address</p>
                        { /* Email */}
                        <div className="row">
                            <div className="col-12">
                                <Form.Group>
                                    <label>Email</label>
                                    <Form.Control
                                        required
                                        type="email"
                                        placeholder="example@email.com"
                                        isInvalid={formErrors && formErrors.email}
                                        onChange={(e) => setField("email", e.target.value)}
                                    />
                                    <Form.Control.Feedback className="text-danger" type="invalid">
                                        Email is required
                                    </Form.Control.Feedback>

                                </Form.Group>
                            </div>
                        </div>

                    

                        <div className="row" style={{ marginTop: 20 }}>
                            <div className="col-6">
                                <button type="submit" className="btn btn-primary">Send Reset Link</button>
                            </div>
                        
                        </div>
                    </Form>
                )}
            </div>
        </main>
  )
}
